import { render, staticRenderFns } from "./ChangeLogsPage.vue?vue&type=template&id=25843262&scoped=true"
import script from "./ChangeLogsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeLogsPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25843262",
  null
  
)

export default component.exports